import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DELETE_WAREHOUSE_VEHICLE_SETUP_',
  }
);

export interface DeleteWarehouseVehicleSetupState {
  id: number | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface DeleteWarehouseVehicleSetupRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: DeleteWarehouseVehicleSetupState = {
  id: null,
  loading: false,
  errorMessage: null,
};

const request = (
  state: DeleteWarehouseVehicleSetupState,
  action: DeleteWarehouseVehicleSetupRequestAction
) =>
  update(state, {
    id: { $set: action.id },
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DeleteWarehouseVehicleSetupState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const failure = (
  state: DeleteWarehouseVehicleSetupState,
  action: FailureAction
) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: DeleteWarehouseVehicleSetupState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const deleteWarehouseVehicleSetup = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const DeleteWarehouseVehicleSetupTypes = Types;
export const DeleteWarehouseVehicleSetupActions = Creators;
